export default __webpack_public_path__ + "static/media/dragIndicator.d38b89de.svg";